import { render, staticRenderFns } from "./CatalogItemCreate.vue?vue&type=template&id=25c10a79&"
import script from "./CatalogItemCreate.vue?vue&type=script&lang=js&"
export * from "./CatalogItemCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports